import { Flex, Typography } from 'antd';
import { PersonalInfoList } from 'entities/user/components';
import { startCase } from 'lodash';
import { useSelector } from 'react-redux';
import { getUserName } from 'shared/config/store/reducers/userSlice';
import classes from './ProfileLayout.module.css';
import { UserAvatar } from 'entities/user';

const ProfileLayout = () => {
  const name = useSelector(getUserName);

  return (
    <Flex vertical gap={32}>
      <Flex align='center' gap={12}>
        <UserAvatar size={96} />
        <Typography.Text className={classes.name}>
          {startCase(name.toLocaleLowerCase())}
        </Typography.Text>
      </Flex>
      <PersonalInfoList />
    </Flex>
  );
};

export default ProfileLayout;
